import React from "react";
import { ClassroomForm } from "../../components/Forms/ClassroomForm/index";

const NewClassroom = () => {
  return <ClassroomForm />;
};

export default NewClassroom;
